import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import { Icon } from "@iconify/react/dist/iconify.js";
import { usePuck } from "@measured/puck";

const EditorHeader = () => {
    const { appState } = usePuck();

    // @ts-ignore
    const { hero, readTime, title } = appState.data.root.props;

    return (
        <>
            <header className={`transition-theme py-6 top-0 z-50`}>
                <Container className="relative z-20">
                    <Row className='justify-between'>
                        <Column xl={2}>
                            <img src="/storage/static/accord-logo-full.svg" alt="Accord Logo" width={131} height={40} />
                        </Column>
                        <Column xl={8} className='flex justify-end'>
                            <div className="flex gap-x-6">

                                <button type='button' className='w-10 h-10 flex items-center justify-center p-2 bg-accordorange rounded-full transition-theme hover:opacity-75'>

                                    <Icon icon={`ph:magnifying-glass-bold`} width={24} className='text-arcticMist' />
                                </button>
                                <button type='button' className='w-10 h-10 flex items-center justify-center p-2 bg-royalPeriwinkle rounded-full transition-theme hover:opacity-75'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect x="6" y="17" width="16" height="2" rx="1" fill="#E8EEF2" />
                                        <rect x="4" y="11" width="18" height="2" rx="1" fill="#E8EEF2" />
                                        <rect x="2" y="5" width="20" height="2" rx="1" fill="#E8EEF2" />
                                    </svg>
                                </button>
                                <button type='button' className='w-10 h-10 flex items-center justify-center p-2 bg-electricBlue rounded-full transition-theme hover:opacity-75 text-arcticMist text-14 leading-16 tracking-[0.21px]'>
                                    AA
                                </button>
                            </div>
                        </Column>
                    </Row>
                </Container>
            </header>
            {hero &&
                <section id="hero-scene" className='-mt-22 relative min-h-[100%] mb-14'>
                    <div className='object-cover bg-no-repeat bg-center bg-cover h-screen' style={{ backgroundImage: `url(${hero})` }}>
                        <div className="absolute inset-0 w-full h-full bg-gradientArticle"></div>
                        <Container className='relative z-10 h-full'>
                            <Row className='items-center'>
                                <Column className='h-full flex flex-col min-h-[calc(100vh_-_304px)]'>
                                    <Row className="my-auto justify-center">
                                        <Column xl={10} className="text-center">
                                            <h1 className='h1 text-arcticMist font-semibold tracking-[1.2px] mb-2'>{title}</h1>
                                            <p className='mb-6 text-accordorange h4'>
                                                Czas czytania: {readTime} min
                                            </p>
                                        </Column>
                                    </Row>
                                </Column>
                            </Row>
                        </Container>
                    </div>
                </section>
            }
        </>
    )
}

export default EditorHeader;